import { useRef, useState } from "preact/hooks";
import { useLocation } from "wouter-preact";
import { Disclaimer } from "../components/Disclaimer";
import { SidebarTrigger } from "../components/Sidebar";
import { CharCount } from "../components/CharCount";
import { autosize } from "../lib/textarea";
import { MAX_QUESTION_LENGTH } from "../lib/config";
import { resetConversation, submitQuestion } from "../state";

export function Ask() {
  const [value, setValue] = useState("");
  const ref = useRef<HTMLTextAreaElement>(null);
  const [, navigate] = useLocation();

  function ask() {
    const question = value.trim();
    if (!question) return;
    // "Ask the judge" always starts a fresh conversation, even if we arrived
    // here via browser Back with a previous thread still in memory.
    resetConversation();
    void submitQuestion(question);
    navigate("/chat");
  }

  return (
    <div class="view">
      <header class="topbar content">
        <div class="topbar__left">
          <SidebarTrigger />
        </div>
      </header>

      <main class="view__center content">
        <div class="ask__hero">
          <h1 class="ask__title">
            Ask the <em>judge</em>.
          </h1>
          <p class="ask__lede">
            Rules questions for Flesh and Blood.
            <br />
            Describe the board-state and what you're trying to do.
          </p>
        </div>

        <form
          class="ask__form"
          onSubmit={(event) => {
            event.preventDefault();
            ask();
          }}
        >
          <textarea
            ref={ref}
            class="textarea ask__textarea"
            rows={4}
            maxLength={MAX_QUESTION_LENGTH}
            placeholder="e.g. My opponent attacks with a hammer for 4 and I want to block with…"
            aria-label="Your question"
            value={value}
            onInput={(event) => {
              setValue(event.currentTarget.value);
              autosize(event.currentTarget);
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter" && !event.shiftKey) {
                event.preventDefault();
                ask();
              }
            }}
          />

          <div class="ask__actions">
            <span class="ask__count">
              <span class="ask__hint">
                Enter to ask · Shift+Enter for a new line
              </span>
              <CharCount length={value.length} />
            </span>
            <button
              type="submit"
              class="btn btn--primary"
              disabled={!value.trim()}
            >
              Ask the judge
            </button>
          </div>
        </form>

        <Disclaimer />
      </main>
    </div>
  );
}
